export default "__VITE_PUBLIC_ASSET__cc18eb86__"